import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import '../../assets/css/partners/partners.css';
import { CustomColumnDef, FilteringList } from '../../components/filteringList/FilteringList';
import CompanyInfoCard from '../../components/companyInfo/CompanyInfoCard';
import { Partner } from '../../model/Partner';
import { useNavigate} from 'react-router-dom';
import { sysStatusToString, sysStatusToCode } from '../../utils/define';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PartnersPage = () => {
  const { authData } = useAuth();
  const navigate = useNavigate();

  // 認証情報がない場合はログインページへリダイレクト
  useEffect(() => {
    if (!authData) {
      navigate('/login');
    }
  }, [authData]);

  const partnerListColumns = React.useMemo<CustomColumnDef<Partner>[]>(
    () => [
      {
        accessorFn: row => row.partnerName,
        id: 'partnerName',
        cell: info => info.getValue(),
        header: () => <span>販売会社名</span>
      },
      {
        accessorFn: row => row.organization,
        id: 'organization',
        cell: info => info.getValue(),
        header: () => <span>組織ID</span>,
      },
      {
        accessorFn: row => row.sysStatus,
        id: 'sysStatus',
        cell: info => info.getValue(),
        header: () => <span>システム種別</span>,
      },
      {
        accessorFn: row => row.staffEmail,
        id: 'staffEmail',        
        cell: info => info.getValue(),
        header: () => <span>担当者メールアドレス</span>,
      },
      {
        accessorFn: row => row.staffName,
        id: 'staffName',
        cell: info => info.getValue(),
        header: () => <span>担当者指名</span>,
      },
      {
        accessorKey: 'clientCount',
        header: () => <span>お客様（顧客）数</span>,
        meta: {
          filterVariant: 'range',
          bodyTextAlign: 'center',
          maxWidth: '140px',
        },
      },
      {
        accessorKey: 'vehicleCount',
        header: () => <span>車両数</span>,
        meta: {
          filterVariant: 'range',
          bodyTextAlign: 'center',
          maxWidth: '100px',
        },
      },
    ],
    []
  );
  
  const [myCompany, setMyCompany] = useState({
    infoKind: "販売会社",
    companyName: '',
    organization: '',
    address: '',
    phone: '',
    agreement: {
      startDate: '',
      endDate: ''
    },
    staffName: '',
    staffNameKana: '',
    staffPhone: '',
    staffMail: '',
    sysStatus: '',
  });

  const [partnerList, setPartnerList] = useState([]);
  useEffect(() => {
  }, [partnerList]);  // partnerListが更新された時に実行
  
  useEffect(() => {
    interface partner {
      id: string;
      company: string;
      organization: string;
      sys_status: string;
      staff_email: string;
      staff_name: string;
      client_count: string;
      vehicle_count: string;
    }

    axios.get(`${API_BASE_URL}/partners?admin_id=${authData.admin_id}`)
      .then(response => {
        if (response.status === 200) {
          console.log(`api call success endpoint: ${API_BASE_URL}/partners?admin_id=${authData.admin_id}`)

          setMyCompany({
            infoKind: "販売会社",
            companyName: response.data.myPartner.company,
            organization: response.data.myPartner.organization,
            address: response.data.myPartner.address,
            phone: response.data.myPartner.phone_number,
            agreement: {
              startDate: response.data.myPartner.agreement_start_date,
              endDate: response.data.myPartner.agreement_end_date,
            },
            staffName: response.data.myPartner.staff_name,
            staffNameKana: response.data.myPartner.staff_name_kana,
            staffPhone: response.data.myPartner.staff_phone_number || response.data.myPartner.staff_phone_number !== '' ? response.data.myPartner.staff_phone_number: "設定なし",
            staffMail: response.data.myPartner.staff_email || response.data.myPartner.staff_email !== '' ? response.data.myPartner.staff_email : "設定なし",
            sysStatus: response.data.myPartner.sys_status
          });

          let list =  response.data.partners.map((obj: partner) => ({            
            isCheck: false,
            id: obj.id,
            partnerName: obj.company,
            organization: obj.organization,
            sysStatus: sysStatusToString(obj.sys_status),
            staffEmail: obj.staff_email,
            staffName: obj.staff_name,
            clientCount: obj.client_count,
            vehicleCount: obj.vehicle_count,
          }));          
          setPartnerList(list);
        } else {
          console.error('get partners failed:', response.data.message || 'Unknown error');
        }
      })
      .catch(error => {
        console.error('Error during login API call:', error);
      });
    
  }, []);
  
  const [selected, setSelected] = useState({});


  return (
    <div className="mx-auto my-2" style={{width: "99%"}}>      
      <CompanyInfoCard companyInfo={myCompany} />
      <div className="p-1">
        <h5 className='m-0 p-2'>販売会社一覧</h5>
      </div>      
      <FilteringList 
          columns={partnerListColumns} 
          datas={partnerList}
          onClick={(partner:Partner)=>{
            console.log("clicked: " + JSON.stringify(partner));                     
            navigate(`/partner/${partner.id}`,{
              state:{
                adminId: authData.admin_id,
                partnerId: partner.id,
                sysStatus: sysStatusToCode(partner.sysStatus)
              }
            });
          }}
        />
    </div>
  );
}

export default PartnersPage;